import { render, staticRenderFns } from "./CService2.vue?vue&type=template&id=14831032"
import script from "./CService2.vue?vue&type=script&lang=js"
export * from "./CService2.vue?vue&type=script&lang=js"
import style0 from "./CService2.vue?vue&type=style&index=0&id=14831032&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports